import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

class LoginLinks extends React.PureComponent {
	render() {
		const { translations } = this.props;

		return (
			<div className="login-links">
				<Link to={"/reviewer/request-password"}>
					{translations.sections.reviewer_login_form.forgot_password_button}
				</Link>
				<Link to={"/reviewer/register"}>
					{translations.sections.reviewer_login_form.contact_button}
				</Link>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations
	};
};

export default connect(mapStateToProps)(LoginLinks);



// WEBPACK FOOTER //
// ./src/components/reviewer/login/LoginLinks.js